function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1327",
  "data-name": "Group 1327",
  transform: "translate(0.403 0.403)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1321",
  "data-name": "Group 1321",
  transform: "translate(26.064 18.012)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1315",
  "data-name": "Group 1315",
  transform: "translate(40.686 11.625)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_783",
  "data-name": "Path 783",
  d: "M102.9,10.812h-93A2.906,2.906,0,1,1,9.906,5h93a2.906,2.906,0,0,1,0,5.812Z",
  transform: "translate(-7 -5)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1316",
  "data-name": "Group 1316",
  transform: "translate(40.686 52.311)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_784",
  "data-name": "Path 784",
  d: "M102.9,17.812h-93a2.906,2.906,0,1,1,0-5.812h93a2.906,2.906,0,0,1,0,5.812Z",
  transform: "translate(-7 -12)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1317",
  "data-name": "Group 1317",
  transform: "translate(40.686 92.997)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_785",
  "data-name": "Path 785",
  d: "M102.9,24.812h-93a2.906,2.906,0,1,1,0-5.812h93a2.906,2.906,0,0,1,0,5.812Z",
  transform: "translate(-7 -19)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1318",
  "data-name": "Group 1318",
  transform: "translate(0 81.372)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_786",
  "data-name": "Path 786",
  d: "M14.531,46.062A14.531,14.531,0,1,1,29.062,31.531,14.547,14.547,0,0,1,14.531,46.062Zm0-23.249a8.718,8.718,0,1,0,8.718,8.718A8.729,8.729,0,0,0,14.531,22.812Z",
  transform: "translate(0 -17)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1319",
  "data-name": "Group 1319",
  transform: "translate(0 40.686)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_787",
  "data-name": "Path 787",
  d: "M14.531,39.062A14.531,14.531,0,1,1,29.062,24.531,14.547,14.547,0,0,1,14.531,39.062Zm0-23.249a8.718,8.718,0,1,0,8.718,8.718A8.729,8.729,0,0,0,14.531,15.812Z",
  transform: "translate(0 -10)",
  fill: "#d5d5d5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1320",
  "data-name": "Group 1320"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_788",
  "data-name": "Path 788",
  d: "M14.531,32.062A14.531,14.531,0,1,1,29.062,17.531,14.547,14.547,0,0,1,14.531,32.062Zm0-23.249a8.718,8.718,0,1,0,8.718,8.718A8.729,8.729,0,0,0,14.531,8.812Z",
  transform: "translate(0 -3)",
  fill: "#d5d5d5"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1325",
  "data-name": "Group 1325"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1381",
  "data-name": "Group 1381"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y1: 140.343,
  x2: 181.755,
  transform: "translate(5.358 3.057)",
  fill: "none",
  stroke: "#d5d5d5",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_70",
  "data-name": "Line 70",
  y1: 142.119,
  x2: 184.056,
  transform: "translate(1 1)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_774",
  "data-name": "Path 774",
  d: "M0,142.119,184.056,0",
  transform: "translate(5.115 5.115)",
  fill: "none",
  stroke: "#f5f5f5",
  strokeLinecap: "round",
  strokeWidth: 2
}))));

var SvgNoData = function SvgNoData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190.976,
    height: 149.039,
    viewBox: "0 0 190.976 149.039",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no_data.ccf3c0fc.svg";
export { ForwardRef as ReactComponent };